export default {
  manageTeam: {
    active: 'Aktiv',
    add: 'Hinzufügen',
    addFailure: 'Teammitglied konnte nicht hinzugefügt werden, bitte versuchen Sie es erneut',
    addingTeamMember: 'Teammitglied hinzufügen',
    addSuccess: '{n} wurde dem Team hinzugefügt',
    //dynamic use
    addTeamMember: 'Teammitglied hinzufügen',
    canAccessSettings: 'Zugriff auf Einstellungen',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    deleteFailure: 'Teammitglied konnte nicht gelöscht werden, bitte versuchen Sie es erneut',
    teamMemberFailureNoConnection: 'Keine Internetverbindung, bitte versuchen Sie es erneut, wenn Ihre Verbindung wiederhergestellt wurde',
    deletePhoto: 'Foto löschen',
    deleteSuccess: '{n} wurde aus dem Team gelöscht',
    //dynamic use
    deleteTeamMember: 'Teammitglied löschen',
    deleteTeamMemberCheck: 'Sind Sie sicher, dass Sie das Teammitglied löschen möchten?',
    deletingTeamMember: 'Teammitglied wird gelöscht',
    displayName: 'Anzeigename',
    displayNameMustBeUnique: 'Der Anzeigename muss eindeutig sein',
    editTeamMember: 'Teammitglied bearbeiten',
    fullName: 'Vollständiger Name',
    fullNameMustBeUnique: 'Der vollständige Name muss eindeutig sein',
    inactive: 'Inaktiv',
    justNow: 'Gerade eben',
    loadingTeamData: 'Teamdaten werden geladen',
    manageTeam: 'Team verwalten',
    mustBeANumericValue: 'Muss ein numerischer Wert sein',
    noRegisteredMembers: 'Es sind noch keine Teammitglieder hinzugefügt. Fügen Sie das erste Teammitglied jetzt hinzu',
    noRegisteredMembersInSearch: 'Derzeit sind keine registrierten Mitglieder im Team, die Ihrer Suche entsprechen',
    permission: 'Durch Drücken der Schaltfläche "Speichern" bestätigen Sie, dass die ausdrückliche Zustimmung des Teammitglieds zur Aufzeichnung seiner Details vorliegt.',
    photoRequired: 'Das Hochladen eines Fotos ist erforderlich',
    pin: 'PIN',
    pinMustBeAtLeastNCharactersLong: 'Die PIN muss mindestens {n} Zeichen lang sein',
    pinMustBeUnique: 'Die PIN muss eindeutig sein',
    pinMustNotBeMoreThanNCharactersLong: 'Die PIN darf nicht mehr als {n} Zeichen lang sein',
    save: 'Speichern',
    searchForTeamMember: 'Nach Teammitglied suchen',
    selectATeam: 'Ein Team auswählen',
    status: 'Status',
    takePhoto: 'Foto aufnehmen',
    teamCategory: 'Teamkategorie',
    updateFailure: 'Teammitglied konnte nicht aktualisiert werden, bitte versuchen Sie es erneut',
    updateSuccess: '{n} wurde aktualisiert',
    //dynamic use
    updatingTeamMemberDetails: 'Teammitgliedsdetails werden aktualisiert',
    uploadImage: 'Foto aufnehmen oder hochladen',
    uploadPhoto: 'Foto hochladen',
    warning: 'Bitte stellen Sie sicher, dass mindestens ein aktives Teammitglied mit einer PIN und Zugriff auf die Einstellungen vorhanden ist.',
    weight: 'Anzeigereihenfolge',
    weightMustBeGreaterThanOrEqualToN: 'Die Anzeigereihenfolge muss größer oder gleich {n} sein',
    weightMustBeLessThanOrEqualToN: 'Die Anzeigereihenfolge muss kleiner oder gleich {n} sein'
  }
};